export default {
	computed: {
		$currentSeason () {
			return this.$store.getters['user/currentSeason']
		}
	}
}
